import styled from 'styled-components';

export const PageWrapper = styled.div`
	background-color: ${(props) => props.theme.colors.neutral10};
	margin-top: 3rem;
	height: calc(100vh - 3rem);
	overflow-y: scroll;
	scroll-snap-type: y proximity;

	@media only screen and (orientation:landscape) {
		scroll-snap-type: none;
	}
`;